import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EntityType } from "../../../types/ScientificModule";

const initialState: EntityType = {
    id: "",
    country: "",
    description: "",
    status: false,
};

const entitiesSlice = createSlice({
    name: "entities",
    initialState,
    reducers: {
        setEntitiesData: (state, action: PayloadAction<EntityType>) => ({ ...state, ...action.payload }),
        resetEntitiesData: () => ({ ...initialState }),
    },
});

export const { setEntitiesData, resetEntitiesData } = entitiesSlice.actions;

export default entitiesSlice.reducer;
